/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  return function onChange(value) {
    if (typeof props.update === 'function') props.update()
  }
}
